// Author thq
// Date 2021-07-04 23:20:31

import * as model from "@/model/em/spareparts/EmSppWarehousingSpwModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmSppWarehousingSpw(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_SPAREPARTS_URL,
    })
    .buildStore()
